import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSetAtom } from "jotai";
import { singleTestPanelOpenAtom } from "@/atom/singleTestPanel";
import Button from "@/component/Button";
import { LightningBoltIcon } from "@/assets/svgs/icons";


const SingleTestButton: React.FC = () => {
    const intl = useIntl();

    const setSingleTestPanelOpen = useSetAtom(singleTestPanelOpenAtom);

    const onClickBtn = (e: React.MouseEvent) => {
        e.preventDefault();
        setSingleTestPanelOpen(prev => !prev);
    };

    useEffect(() => {
        return () => {
            setSingleTestPanelOpen(false);
        };
    }, [setSingleTestPanelOpen]);

    return (
        <Button variant="text"
                onClick={onClickBtn}
        >
            <LightningBoltIcon className="size-3" />
            {intl.formatMessage({ id: 'i00003' })}
        </Button>
    );
};

export default SingleTestButton;
